export const SHOW_WARNING = 'SHOW_WARNING';
export const HIDE_WARNING = 'HIDE_WARNING';
export const ERROR_SAGA = 'ERROR_SAGA';
export const CLEAR_WARNING = 'CLEAR_WARNING';
export const SHOW_INFO = 'SHOW_INFO';

